import { css } from '@emotion/core';
import { media, tokens } from '@domain-group/fe-brary';
import { designTokenFonts } from '@domain-group/fe-co-allhomes-design-system';
var body = designTokenFonts.body;
var colours = tokens.colors;
var textAreaWrapper = {
  base: {
    name: "16839bs",
    styles: "width:100%;padding:0;"
  },
  listing: /*#__PURE__*/css(media('>=tablet'), "{padding:0 10px;}")
};
var comment = /*#__PURE__*/css("width:100%;height:6em;padding:10px;border:1px solid ", colours.neutral.medium.default, ";color:", colours.neutral.heavy.default, ";", body, ";resize:none;border-radius:3px;&:focus{border:2px solid ", colours.neutral.heavy.default, ";}");
export default (appearance => {
  var buildStyle = style => [style.base, typeof style[appearance] === 'function' ? style[appearance](style) : style[appearance]];
  return {
    textAreaWrapper: buildStyle(textAreaWrapper),
    comment
  };
});